import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { DocumentSubjectType } from '@/types'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}
interface DocumentTypeSubjectItem {
  id: DocumentSubjectType
  name: string
}

const values: DocumentTypeSubjectItem[] = [
  { id: DocumentSubjectType.Asset, name: 'Asset' },
  { id: DocumentSubjectType.AssetType, name: 'Asset type' },
  { id: DocumentSubjectType.Package, name: 'Package' },
  { id: DocumentSubjectType.Event, name: 'Event' },
  { id: DocumentSubjectType.Venue, name: 'Venue' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<DocumentTypeSubjectItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
